// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/icons/arrow-double.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/icons/arrow-up.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#popup {
  width: 0;
  height: 0;
}

.bold-fw { 
  font-weight: 600 !important; 
}

.extra-fw { 
  font-weight: 700 !important; 
}

.mobile-fw { 
  display: block !important; 
}

.hidden {
  visibility: hidden;
  font-size: 0;
  width: 0 !important;
  height: 0 !important;
  min-height: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

.none-trans { 
  text-transform: none !important; 
}

.tags__input input {
  height: auto !important;
  padding: 4px 0 2px !important;
}

._refWithNotif.fullWidthLeft #notif_action {
  padding: 0 1em 0 1.5em;
}

._refWithNotif.fullWidthLeft #notif_action { 
  padding: 0 1em 0 1.5em; 
}

._refWithNotif.fullWidthLeft #notif_action section {
  width: auto;
  margin-left: 0;
  margin-right: 0;
}

.clear-li {
  list-style: none;
  padding: 0;
  margin: 0;
}

._refCollapse {
  position: relative;
}

._refCollapseButton {
  padding-right: 12px !important;
  text-align: left;
  width: 84px !important;
  text-transform: none;
  font-size: 13px;
}

._refCollapseButton::after {
  position: absolute;
  content: '';
  right: 0;
  padding: 2px;
  border-style: solid;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-bottom: 2px;
}

._refCollapseButton.is-active::after {
  transform: rotate(-135deg);
  margin-top: 6px;
}

._refHidden ._refLoading {  
  display: none; 
}

.ck-editor.isFocused {
	border: 1px solid var(--pri-clr-ln__fc) !important; 
	border-radius: 6px;
	box-shadow: none;
	outline: none;
	.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable), .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
		border: none;
	}
}

._ref_CKEditorContainer {
  display: flex;
  position: relative;
}

._ref_CKEditorContainer .ck.ck-editor {
  width: 100%;
  max-width: calc(100vw - 30px);
}

.multi-elipsis {
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  white-space: pre-wrap !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
  line-height: 16px;
}

.third-elipsis {
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  white-space: pre-wrap !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
  line-height: 16px;
}

._flyByDFor, ._hipByDFor {
  padding-left: 0.625em !important;
  padding-right: 0.625em !important;
}

._refSortButton { 
  cursor: pointer; 
  width: 100%;
}

._refSortButton i {
  display: inline-block;
  margin-left: -2px;
}

._refSortButton dt {
  display: inline;
  width: auto;
}

._refSortButton.left:after {
  content: '';
  display: none;
}

._refSortButton:after, ._refSortButton.left:before {
  display: inline-block;
  pointer-events: none;
  position: relative;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 12px;
  width: 12px;
  left: -1px;
  top: 2px;
  transform: rotate(-90deg);
}

._refSortButton.ascending:after, ._refSortButton.descending:after, ._refSortButton.left.ascending:before, ._refSortButton.left.descending:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  transform: rotate(0deg);
}

._refSortButton.descending:after, ._refSortButton.descending.left:before { 
  transform: rotate(-180deg); 
}

.loadingWrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 101;
}

.loadingWrapper div {
  position: absolute;
  top: 50%; 
  left: 50%;
  transform: translate(50%,-50%);
}

.loadingOverlay {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
}

.none {
  display: none !important;
}

.freezeColumn {
  position: sticky;
  z-index: 8;
  background: var(--sec-clr-bg);
  align-self: stretch;
}
.is-highlighted {
  background-color: rgba(232, 255, 237, .7);
}

.is-highlighted {
  background-color: rgba(232, 255, 237, .7);
}

.sort-extended button{
  i {
    display: none;
  }
  span {
    display: block;
  }
}

._refTitle {
  color: var(--ter-clr) !important;
  font-weight: 600;
}

@media only screen and (min-width: 375px) {
  ._flyByDFor {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  ._hipByDFor {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
@media only screen and (max-width: 767.9px) {
  ._refScrollContainer { 
    padding-bottom: 69px; 
  }
}
@media only screen and (min-width: 768px) {
  ._ref_CKEditorContainer .ck.ck-editor {
    max-width: calc(100vw - 80px);
    width: 100%;
  }
  .mobile-fw { 
    display: none  !important; 
  }
}
@media only screen and (min-width: 1024px) {
  ._ref_CKEditorContainer .ck.ck-editor { 
    max-width: 760px; 
  }
}
@media only screen and (min-width: 1800px) {
  ._flyByDFor {
    padding-left: 28px !important;
    padding-right: 28px !important;
  }
  ._hipByDFor {
    padding-left: 28px !important;
    padding-right: 28px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/common.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;CACC,kDAAkD;CAClD,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb;EACC,YAAY;CACb;AACD;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;EACvC,2BAA2B;EAC3B,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;EACvC,2BAA2B;EAC3B,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gDAAgD;EAChD,YAAY;EACZ,WAAW;EACX,UAAU;EACV,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,gDAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF","sourcesContent":["#popup {\n  width: 0;\n  height: 0;\n}\n\n.bold-fw { \n  font-weight: 600 !important; \n}\n\n.extra-fw { \n  font-weight: 700 !important; \n}\n\n.mobile-fw { \n  display: block !important; \n}\n\n.hidden {\n  visibility: hidden;\n  font-size: 0;\n  width: 0 !important;\n  height: 0 !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.none-trans { \n  text-transform: none !important; \n}\n\n.tags__input input {\n  height: auto !important;\n  padding: 4px 0 2px !important;\n}\n\n._refWithNotif.fullWidthLeft #notif_action {\n  padding: 0 1em 0 1.5em;\n}\n\n._refWithNotif.fullWidthLeft #notif_action { \n  padding: 0 1em 0 1.5em; \n}\n\n._refWithNotif.fullWidthLeft #notif_action section {\n  width: auto;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.clear-li {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n._refCollapse {\n  position: relative;\n}\n\n._refCollapseButton {\n  padding-right: 12px !important;\n  text-align: left;\n  width: 84px !important;\n  text-transform: none;\n  font-size: 13px;\n}\n\n._refCollapseButton::after {\n  position: absolute;\n  content: '';\n  right: 0;\n  padding: 2px;\n  border-style: solid;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  margin-bottom: 2px;\n}\n\n._refCollapseButton.is-active::after {\n  transform: rotate(-135deg);\n  margin-top: 6px;\n}\n\n._refHidden ._refLoading {  \n  display: none; \n}\n\n.ck-editor.isFocused {\n\tborder: 1px solid var(--pri-clr-ln__fc) !important; \n\tborder-radius: 6px;\n\tbox-shadow: none;\n\toutline: none;\n\t.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable), .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\tborder: none;\n\t}\n}\n\n._ref_CKEditorContainer {\n  display: flex;\n  position: relative;\n}\n\n._ref_CKEditorContainer .ck.ck-editor {\n  width: 100%;\n  max-width: calc(100vw - 30px);\n}\n\n.multi-elipsis {\n  display: -webkit-box !important;\n  -webkit-line-clamp: 2 !important;\n  -webkit-box-orient: vertical !important;\n  overflow: hidden !important;\n  white-space: pre-wrap !important;\n  overflow-wrap: anywhere !important;\n  word-break: break-word !important;\n  line-height: 16px;\n}\n\n.third-elipsis {\n  display: -webkit-box !important;\n  -webkit-line-clamp: 3 !important;\n  -webkit-box-orient: vertical !important;\n  overflow: hidden !important;\n  white-space: pre-wrap !important;\n  overflow-wrap: anywhere !important;\n  word-break: break-word !important;\n  line-height: 16px;\n}\n\n._flyByDFor, ._hipByDFor {\n  padding-left: 0.625em !important;\n  padding-right: 0.625em !important;\n}\n\n._refSortButton { \n  cursor: pointer; \n  width: 100%;\n}\n\n._refSortButton i {\n  display: inline-block;\n  margin-left: -2px;\n}\n\n._refSortButton dt {\n  display: inline;\n  width: auto;\n}\n\n._refSortButton.left:after {\n  content: '';\n  display: none;\n}\n\n._refSortButton:after, ._refSortButton.left:before {\n  display: inline-block;\n  pointer-events: none;\n  position: relative;\n  content: url('../images/icons/arrow-double.svg');\n  height: 12px;\n  width: 12px;\n  left: -1px;\n  top: 2px;\n  transform: rotate(-90deg);\n}\n\n._refSortButton.ascending:after, ._refSortButton.descending:after, ._refSortButton.left.ascending:before, ._refSortButton.left.descending:before {\n  content: url('../images/icons/arrow-up.svg');\n  transform: rotate(0deg);\n}\n\n._refSortButton.descending:after, ._refSortButton.descending.left:before { \n  transform: rotate(-180deg); \n}\n\n.loadingWrapper {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 101;\n}\n\n.loadingWrapper div {\n  position: absolute;\n  top: 50%; \n  left: 50%;\n  transform: translate(50%,-50%);\n}\n\n.loadingOverlay {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  background-color: #fff;\n}\n\n.none {\n  display: none !important;\n}\n\n.freezeColumn {\n  position: sticky;\n  z-index: 8;\n  background: var(--sec-clr-bg);\n  align-self: stretch;\n}\n.is-highlighted {\n  background-color: rgba(232, 255, 237, .7);\n}\n\n.is-highlighted {\n  background-color: rgba(232, 255, 237, .7);\n}\n\n.sort-extended button{\n  i {\n    display: none;\n  }\n  span {\n    display: block;\n  }\n}\n\n._refTitle {\n  color: var(--ter-clr) !important;\n  font-weight: 600;\n}\n\n@media only screen and (min-width: 375px) {\n  ._flyByDFor {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n  ._hipByDFor {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n}\n@media only screen and (max-width: 767.9px) {\n  ._refScrollContainer { \n    padding-bottom: 69px; \n  }\n}\n@media only screen and (min-width: 768px) {\n  ._ref_CKEditorContainer .ck.ck-editor {\n    max-width: calc(100vw - 80px);\n    width: 100%;\n  }\n  .mobile-fw { \n    display: none  !important; \n  }\n}\n@media only screen and (min-width: 1024px) {\n  ._ref_CKEditorContainer .ck.ck-editor { \n    max-width: 760px; \n  }\n}\n@media only screen and (min-width: 1800px) {\n  ._flyByDFor {\n    padding-left: 28px !important;\n    padding-right: 28px !important;\n  }\n  ._hipByDFor {\n    padding-left: 28px !important;\n    padding-right: 28px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
